import { Services } from '../../types/services';

// Interfaces
interface State {
    // Empty state
}

interface Action {
    type: string;
    payload?: unknown;
}

const initialState: State = {
    // Empty state
};

export const reducer = (state = initialState, action: Action): State => {
    switch (action.type) {
        default:
            return state;
    }
};

export const actions = (services: Services) => {
    const axiosCall = services.axios.Axios();

    const createDomain = (payload: Record<string, unknown>) => async () =>
        axiosCall
            .post('admin/domains', { ...payload })
            .then((res) => res.data)
            .catch((err) => {
                throw err;
            });

    const deletePartnerDomain = (id: string) => async () =>
        await axiosCall.delete('admin/domains/' + id);

    return {
        createDomain,
        deletePartnerDomain,
    };
};

